export default __webpack_public_path__ + "static/media/focus.7910c865.png";